import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Dropdown, Icon, Label, Button } from "semantic-ui-react";
import CSVDownloadButton from "../components/layout/SuperAdminCSVDownloadButton";
import PlanCardModal from "../components/modal/PlanCardModal";
// import { sendRefund } from "../store/actions/superAdminNewRequest";
import { handleNewRequestStatus } from "../store/actions/superAdminNewRequestStatus";
import ConfirmModal from "../components/layout/SignUpModal/ConfirmModal";
import "./NewSignupInfo.css";

const NewSignupInfo = (props) => {
  const [open, setOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const dispatch = useDispatch();

  const handleApproval = (newStatus, data, oldStatus) => {
    dispatch(handleNewRequestStatus(data, newStatus, oldStatus));
  };
  const handleRefundModal = () => {
    setConfirmModal(true);
  };
  return (
    <>
      <div className="AthleteDetailsBackground new-signup">
        {confirmModal && (
          <ConfirmModal
            newUser={props.newUser}
            selectedPlan={props.selectedPlan}
            open={confirmModal}
            close={() => setConfirmModal(false)}
          />
        )}
        <div className="AthleteDetailsBannerBar"></div>
        <div className="signup-info-page">
          {props.newUser && (
            <div className="AthleteSearchBanner main-filter-event">
              <h1>{props.newUser.fname + " " + props.newUser.lname}</h1>
              <div className="AthleteSearchFilterContainer">
                {props.refundError && !props.newUser.refund && (
                  <p className="cu-center" style={{ color: "#800000" }}>
                    {props.refundError}
                  </p>
                )}
              </div>
              <div className="signup-bg">
                <div className="signup-bg-header">
                  <div className="one">
                    <Dropdown
                      disabled={!props.newUser.paymentDone}
                      placeholder={
                        props.newUser.status
                          ? "Approved"
                          : props.newUser.status === null
                          ? "Pending"
                          : "Disapprove"
                      }
                      selection
                      onChange={(not, data) =>
                        handleApproval(
                          data.value,
                          props.newUser,
                          props.newUser.status
                        )
                      }
                      options={[
                        {
                          key: 1,
                          text: "Approve",
                          value: true,
                          disabled: props.newUser.status,
                        },
                        {
                          key: 2,
                          text: "Pending",
                          value: null,
                          disabled:
                            props.newUser.status === null ? true : false,
                        },
                        {
                          key: 3,
                          text: "Disapprove",
                          value: false,
                          disabled:
                            props.newUser.status === false ? true : false,
                        },
                      ]}
                    />
                  </div>
                  <div className="two">
                    <div className="btn-box d-flex">
                      <CSVDownloadButton data={props.newUser} />
                      <Button
                        disabled={!props.newUser.paymentDone}
                        loading={props.refundInitiate}
                        positive={props.refundDone}
                        color={props.refundError ? "youtube" : "red"}
                        icon={<Icon name="redo" size="large" />}
                        content={
                          props.selectedPlan?.otp === false
                            ? "Stop Subscription"
                            : "Refund"
                        }
                        className="refund-btn"
                        onClick={handleRefundModal}
                      />
                    </div>
                  </div>
                </div>

                {props.newUser.customerType && (
                  <div className="datas">
                    {props.newUser.customerType === "student" && (
                      <p>Student Athelete</p>
                    )}
                    {props.newUser.customerType === "transfer" && (
                      <p>College Transfer</p>
                    )}
                  </div>
                )}

                <div className="datas">
                  <p>Email:</p>
                  <span>{props.newUser.email}</span>
                </div>

                {props.newUser.dob && (
                  <div className="datas">
                    <p>Date of Birth: </p>
                    <span>
                      {props.newUser.dob.toDate().toLocaleDateString("en-US")}
                    </span>
                  </div>
                )}

                {props.newUser.gmail && (
                  <div className="datas">
                    <p>Gmail: </p>
                    <span>{props.newUser.gmail}</span>
                  </div>
                )}

                {props.newUser.athletesPhone && (
                  <div className="datas">
                    <p>Atheletes Phone: </p>
                    <span>{props.newUser.athletesPhone}</span>
                  </div>
                )}

                {props.advocateName && (
                  <div className="datas">
                    <p>Advocate: </p>
                    <span>{props.advocateName}</span>
                  </div>
                )}

                {props.newUser.parentsEmail1 && (
                  <div className="datas">
                    <p>Parents Email 1: </p>
                    <span>{props.newUser.parentsEmail1}</span>
                  </div>
                )}
                {props.newUser.parentsEmail2 && (
                  <div className="datas">
                    <p>Parents Email 2: </p>
                    <span>{props.newUser.parentsEmail2}</span>
                  </div>
                )}

                {props.newUser.parentsPhone1 && (
                  <div className="datas">
                    <p>Parents Phone1: </p>
                    <span>{props.newUser.parentsPhone1}</span>
                  </div>
                )}

                {props.newUser.parentsPhone2 && (
                  <div className="datas">
                    <p>Parents Phone2: </p>
                    <span>{props.newUser.parentsPhone2}</span>
                  </div>
                )}

                {props.newUser.travelTeam && (
                  <div className="datas">
                    <p>Travel Team: </p>
                    <span>{props.newUser.travelTeam}</span>
                  </div>
                )}

                {props.newUser.classYear && (
                  <div className="datas">
                    <p>Class Year: </p>
                    <span>{props.newUser.classYear}</span>
                  </div>
                )}

                {props.newUser.sport && (
                  <div className="datas">
                    <p>Sports: </p>
                    <span>{props.newUser.sport}</span>
                  </div>
                )}

                {props.newUser.primaryPosition && (
                  <div className="datas">
                    <p>Primary Position: </p>
                    <span>{props.newUser.primaryPosition}</span>
                  </div>
                )}

                {props.newUser.secondaryPosition && (
                  <div className="datas">
                    <p>Secondary Position: </p>
                    <span>{props.newUser.secondaryPosition}</span>
                  </div>
                )}

                {props.newUser.fatherName && (
                  <div className="datas">
                    <p>Father Name: </p>
                    <span>{props.newUser.fatherName}</span>
                  </div>
                )}

                {props.newUser.motherName && (
                  <div className="datas">
                    <p>Mother Name: </p>
                    <span>{props.newUser.motherName}</span>
                  </div>
                )}

                {props.newUser.athletesPhone && (
                  <div className="datas">
                    <p>Athlete Phone: </p>
                    <span>{props.newUser.athletesPhone}</span>
                  </div>
                )}

                {props.newUser.resides && (
                  <div className="datas">
                    <p>Resides :</p>
                    <span>{props.newUser.resides}</span>
                  </div>
                )}

                {props.newUser.school && (
                  <div className="datas">
                    <p>School:</p>
                    <span>{props.newUser.school}</span>
                  </div>
                )}

                {props.newUser.ref && (
                  <div className="datas">
                    <p>Referrence:</p>
                    <span>{props.newUser.ref}</span>
                  </div>
                )}

                {props.newUser.mainAgreementUrl && (
                  <div className="datas">
                    <p>Main Agreement:</p>
                    <span>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={props.newUser.mainAgreementUrl}
                      >
                        <button className="pdf-icon">
                          <Icon color="red" name="file pdf" />
                        </button>
                      </a>
                    </span>
                  </div>
                )}

                {props.newUser.secondAgreementUrl && (
                  <div className="datas">
                    <p>Second Agreement:</p>
                    <span>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={props.newUser.secondAgreementUrl}
                      >
                        <button className="pdf-icon">
                          <Icon name="file pdf" />
                        </button>
                      </a>
                    </span>
                  </div>
                )}

                {props.newUser.status !== undefined && (
                  <div className="datas">
                    <p>Status:</p>
                    <Label
                      color={
                        props.newUser.status
                          ? "teal"
                          : props.newUser.status === null
                          ? "yellow"
                          : "red"
                      }
                      tag
                    >
                      {props.newUser.status
                        ? "Approved"
                        : props.newUser.status === null
                        ? "Pending"
                        : "Disapprove"}
                    </Label>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="signup-info-page">
          <div className="AthleteSearchBanner main-filter-event">
            {props.newUser?.paymentMethod && (
              <>
                <div className="step-data">
                  <div className="step-data-header">
                    Payment Information (
                    {props.newUser?.paymentDone ? "Done" : "Not Done"})
                  </div>
                </div>

                <div className="signup-bg">
                  {props.selectedPlan &&
                    Object.keys(props.selectedPlan).length > 0 && (
                      <div className="datas">
                        <p>Payment Plan:</p>
                        <span>
                          <button
                            className="pdf-icon"
                            onClick={() => setOpen(true)}
                          >
                            $ {props.selectedPlan.amount * 0.01}
                          </button>
                        </span>
                      </div>
                    )}

                  {props.newUser.paymentMethod && (
                    <>
                      <div className="datas">
                        <p>Payment Method:</p>
                        {props.newUser.paymentMethod === "echeck" && (
                          <span>Bank Transfer</span>
                        )}
                        {props.newUser.paymentMethod === "credit_card" && (
                          <span>Credit Card</span>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {props.selectedPlan && props.newUser?.selectedPlan && (
        <PlanCardModal
          plan={props.selectedPlan}
          open={() => setOpen(true)}
          close={() => setOpen(false)}
          hidden={open}
        />
      )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  let newUser = null;
  let advocateName = null;
  let selectedPlan = null;

  if (
    state.firestore.data.testNewRequests &&
    Object.keys(state.firestore.data.testNewRequests).length > 0 &&
    ownProps?.match?.params?.id &&
    state.firestore.data.testNewRequests[ownProps.match.params.id]
  ) {
    newUser = state.firestore.data.testNewRequests[ownProps.match.params.id];
  }

  if (
    state.firestore.data.advocates &&
    Object.keys(state.firestore.data.advocates).length > 0 &&
    ownProps?.match?.params?.id &&
    newUser &&
    state.firestore.data.advocates[newUser.advocate]
  ) {
    advocateName = state.firestore.data.advocates[newUser.advocate].name;
  }

  if (
    newUser &&
    Object.keys(newUser).length > 0 &&
    newUser.selectedPlan &&
    state.firestore.data.testPriceList &&
    Object.keys(state.firestore.data.testPriceList).length > 0
  ) {
    selectedPlan = state.firestore.data.testPriceList[newUser.selectedPlan];
  }

  return {
    newUser,
    advocateName,
    selectedPlan,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    refundInitiate: state.signup.refundInitiate,
    refundError: state.signup.refundError,
    refundDone: state.signup.refundDone,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "testNewRequests",
      },
      {
        collection: "advocates",
      },
      {
        collection: "testPriceList",
      },
    ];
    return firestoreArray;
  })
)(NewSignupInfo);
